import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { resolveApiBusinessKey } from '../config/tenant.config';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const token = auth.validToken();
  const headers: Record<string, string> = {};

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const businessKey = resolveApiBusinessKey(router.url, auth.businessKey(), !!token);
  if (businessKey) {
    headers['X-Business-Key'] = businessKey;
  }

  const authorized = Object.keys(headers).length > 0 ? req.clone({ setHeaders: headers }) : req;

  return next(authorized).pipe(
    catchError((err: HttpErrorResponse) => {
      const isLogin = req.url.includes('/auth/login');
      if (err.status === 401 && !isLogin) {
        auth.logout();
        if (router.url.startsWith('/admin')) {
          void router.navigateByUrl('/login');
        }
      }

      // Empty 401/403 bodies become SyntaxError in Firefox when HttpClient parses JSON.
      if (err.error instanceof SyntaxError) {
        return throwError(
          () =>
            new HttpErrorResponse({
              error: { error: err.status === 401 ? 'Unauthorized' : err.statusText || 'Request failed' },
              headers: err.headers,
              status: err.status,
              statusText: err.statusText,
              url: err.url ?? undefined
            })
        );
      }

      return throwError(() => err);
    })
  );
};